import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { footerStyles as sx } from './Footer.styles';

export const Footer = () => {
	const { t } = useTranslation();
	const currentYear = new Date().getFullYear();

	return (
		<Box component='footer' sx={sx.root}>
			<Typography variant='body2'>
				{t(
					'Copyright © 2010 – {{currentYear}} Veeva Systems. All rights reserved |',
					{ currentYear }
				)}{' '}
				<Link
					href='https://www.veeva.com/privacy/'
					target='_blank'
					rel='noopener noreferrer'
					underline='hover'
					color='inherit'
					sx={sx.link}
				>
					{t('Privacy Policy')}
				</Link>
			</Typography>
		</Box>
	);
};
